import { IPlanContent } from '../typings/planContent.types';
import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import {
  byoBatteryAddon,
  defaultEstimatesDialog,
  defaultKeyDetails,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
} from './common/planDefaults';
import { InternetOfferPerk } from './common/internetOfferPerk';
import { createSolarInfoContent } from './common/solarInfoContent';

const PLAN_TONE = 'caution';

export const originGoSolarContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Go Solar']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 12 month benefit period',
      },
    },
    keyFeatures: {
      defaultState: {
        defaultFuel: [],
      },
    },
    signUpOptions: {
      defaultState: {
        defaultFuel: [],
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: defaultKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: [...dualKeyDetailsAddons, byoBatteryAddon],
        gas: [],
        electricity: [...electricityKeyDetailsAddons, byoBatteryAddon],
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: [],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'grey',
              odsCore: 'neutral',
            },
            promobox: {
              styleGuide: 'lightOrange',
              odsCore: PLAN_TONE,
            },
            bannerText: {
              styleGuide: 'grey56',
              odsCore: 'neutralDark',
            },
          },
          imageUrl:
            'https://res.cloudinary.com/originenergy/image/upload/v1728625552/spot-illustrations/spot_solar.svg',
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-go-solar-variable_elec.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-go-solar-variable_dual.svg',
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel: 'A higher than standard feed-in tariff, plus variable rates',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions-origin-go-solar/',
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
    solarInfo: {
      defaultState: {
        defaultFuel: {
          title: 'Origin Go Solar',
          content: createSolarInfoContent('Origin Go Solar'),
        },
      },
    },
  },
};
